import { apiPrivateAxios } from "../../axios";
import { IFacilitySettings } from "./types";

export const facilitySettingRequest = {
  getFacilitySettings: (): Promise<IFacilitySettings> =>
    apiPrivateAxios.get("/facility-setting"),
  updateFacilitySettings: (
    data: IFacilitySettings
  ): Promise<IFacilitySettings> => apiPrivateAxios.put("/facility-setting", data),
};
